import { render } from "./AnalyticsNumDiamonds.vue?vue&type=template&id=32cad53a&scoped=true"
import script from "./AnalyticsNumDiamonds.vue?vue&type=script&lang=js"
export * from "./AnalyticsNumDiamonds.vue?vue&type=script&lang=js"

import "@/css/components/analytics-num-diamonds.css?vue&type=style&index=0&id=32cad53a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32cad53a"]])

export default __exports__